import { createFileRoute, notFound } from '@tanstack/react-router'
import { creditUsage } from '@/lib/queries/credit-usage'
import { organizationMembership } from '@/lib/queries/organization-memberships'
import { organization } from '@/lib/queries/organizations'
import { decodeId, encodeId } from '@/lib/short-uuid'
import { OrganizationLayout } from '@/features/organizations/layout'

export const Route = createFileRoute('/_authenticated/org/$orgId')({
  params: {
    parse: (rawParams: { orgId: string }) => {
      try {
        return { orgId: decodeId(rawParams.orgId) }
      } catch {
        return { orgId: rawParams.orgId }
      }
    },
    stringify: (params: { orgId: string }) => ({
      orgId: encodeId(params.orgId),
    }),
  },
  staticData: { sidebar: 'organization' },
  beforeLoad: async ({ params, context }) => {
    const { currentProfile } = context

    let currentOrgMembership
    let entitlements
    try {
      currentOrgMembership = await context.queryClient.query({
        ...organizationMembership.findOneByUserAndOrg(
          currentProfile.id,
          params.orgId
        ),
        staleTime: 'static',
      })

      if (!currentOrgMembership) {
        throw new Error('No membership')
      }

      const org = await context.queryClient.query({
        ...organization.findOne(params.orgId),
        staleTime: 'static',
      })
      // What the billing account's plan includes. Every feature gate below
      // this route reads it from context — nothing per user.
      entitlements = await context.queryClient.query({
        ...creditUsage.entitlements(org.billing_account_id),
        staleTime: 'static',
      })
    } catch {
      throw notFound()
    }

    return {
      currentOrgMembership,
      isOrgAdmin: currentOrgMembership.role === 'org_admin',
      entitlements,
    }
  },
  component: OrganizationLayout,
})
